import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/egram-logo.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="rk-footer">
      <div className="rk-footer-grid">
        {/* brand */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ background: "#fff", borderRadius: 10, padding: 8 }}>
              <img src={logo} alt="रोषणखेडा ग्रामपंचायत" style={{ height: 38, width: "auto", objectFit: "contain" }} />
            </div>
          </div>
          <p style={{ fontSize: 14.5, lineHeight: 1.7, marginTop: 16, color: "#a9c0b3" }}>
            रोषणखेडा ग्रामपंचायत डिजिटल पोर्टल हे पारदर्शक, आधुनिक व नागरिकाभिमुख प्रशासनाचे व्यासपीठ आहे. शासकीय सेवा, योजना व विकासकामांची माहिती एका ठिकाणी.
          </p>
        </div>

        {/* quick links */}
        <div>
          <h4 className="rk-footer-head">द्रुत दुवे</h4>
          <div className="rk-footer-links">
            <Link to="/">मुख्यपृष्ठ</Link>
            <Link to="/about">गावाची माहिती</Link>
            <Link to="/services">सेवा</Link>
            <Link to="/schemes">शासकीय योजना</Link>
            <Link to="/gallery">छायाचित्रे</Link>
          </div>
        </div>

        {/* services */}
        <div>
          <h4 className="rk-footer-head">सेवा</h4>
          <div className="rk-footer-links">
            <Link to="/services">जन्म प्रमाणपत्र</Link>
            <Link to="/services">मृत्यू प्रमाणपत्र</Link>
            <Link to="/services">उत्पन्न प्रमाणपत्र</Link>
            <Link to="/services">रहिवासी प्रमाणपत्र</Link>
            <Link to="/notices">सूचना</Link>
          </div>
        </div>

        {/* contact */}
        <div>
          <h4 className="rk-footer-head">संपर्क</h4>
          <div className="rk-footer-contact">
            <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7ab98a" strokeWidth="2" style={{ flexShrink: 0, marginTop: 2 }}><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              ग्रामपंचायत कार्यालय, रोषणखेडा, ता.  वरूड, जि. अमरावती
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7ab98a" strokeWidth="2" style={{ flexShrink: 0 }}><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              +९१ ९९९८८ ८७७७७
            </div>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7ab98a" strokeWidth="2" style={{ flexShrink: 0 }}><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
              gproshankheda@gmail.com
            </div>
          </div>
        </div>
      </div>

      <div className="rk-footer-bottom">
        <span>© {year} ग्रामपंचायत रोषणखेडा. सर्व हक्क राखीव.</span>
        <span>भारत सरकार मान्यताप्राप्त डिजिटल पोर्टल</span>
      </div>
    </footer>
  );
};

export default Footer;
